module.exports = __webpack_public_path__ + "img/symbol_5.214c186d.png";